<script context="module">
    import { writable, get } from 'svelte/store';

    export const panelState = writable('peak');
    export const alwaysVisible = writable(true);

   export function togglePanel(newState) {
        if (newState) {
            // If a new state is provided, set it directly
            setPanelState(newState);
        } else {
            // If no state is provided, toggle as before
            panelState.update(currentState => {
                if (currentState === 'open') return 'peak';
                if (currentState === 'peak') {
                    return get(alwaysVisible) ? 'open' : 'hidden';
                }
                return 'peak';
            });
        }
    }

    export function setPanelState(newState) {
        panelState.update(currentState => {
            if (get(alwaysVisible) && newState === 'hidden') {
                return 'peak';
            }
            return newState;
        });
    }

    export function getInitialState() {
        return {
            panelState: get(panelState),
            alwaysVisible: get(alwaysVisible)
        };
    }
</script>